import { useRouter } from "next/router";

function useIsLogin(): boolean {
  const router = useRouter();

  return router.pathname.indexOf("login") > -1;
}

export default useIsLogin;
